import { DateTime } from 'luxon';

/** Presentations and quiz schedules use French local time. */
export const QUIZ_SCHEDULE_TIMEZONE = 'Europe/Paris';

export function formatQuizScheduleTimeFromDb(iso?: string | null): string {
  if (!iso) {
    return '';
  }

  return DateTime.fromISO(iso, { zone: 'utc' })
    .setZone(QUIZ_SCHEDULE_TIMEZONE)
    .toFormat('HH:mm');
}

export function formatQuizScheduleDateFromDb(iso?: string | null): string {
  if (!iso) {
    return '';
  }

  return DateTime.fromISO(iso, { zone: 'utc' })
    .setZone(QUIZ_SCHEDULE_TIMEZONE)
    .startOf('day')
    .toISO() || '';
}

export function buildQuizScheduleTimestamp(
  dateIso?: string | null,
  timeHm?: string | null
): DateTime | null {
  if (!dateIso || !timeHm) {
    return null;
  }

  const [hour, minute] = timeHm.split(':').map((part) => parseInt(part, 10));
  if (Number.isNaN(hour) || Number.isNaN(minute)) {
    return null;
  }

  const dateInParis = DateTime.fromISO(dateIso).setZone(QUIZ_SCHEDULE_TIMEZONE);

  return DateTime.fromObject({
    year: dateInParis.year,
    month: dateInParis.month,
    day: dateInParis.day,
    hour,
    minute,
    second: 0,
    millisecond: 0,
    zone: QUIZ_SCHEDULE_TIMEZONE,
  });
}

export function isQuizScheduleWindowActive(
  from?: string | null,
  to?: string | null
): boolean {
  if (!from && !to) {
    return true;
  }

  if (!from || !to) {
    return false;
  }

  const now = DateTime.utc().setZone(QUIZ_SCHEDULE_TIMEZONE);
  const fromTime = DateTime.fromISO(from, { zone: 'utc' }).setZone(QUIZ_SCHEDULE_TIMEZONE);
  const toTime = DateTime.fromISO(to, { zone: 'utc' }).setZone(QUIZ_SCHEDULE_TIMEZONE);

  if (!fromTime.isValid || !toTime.isValid) {
    return false;
  }

  return now >= fromTime && now <= toTime;
}
